export const baseURL = "https://ferrywheel.ryzolive.app/";
export const adminBaseURL = "https://admin.ryzolive.app/";
export const key = "5TIvw5cpc0";
